module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sales-pro-onboarding/success-orb.svg"